import React, { useState, useEffect } from "react";
import Tag from "../../../../generic/tag";
import OverflowButton from "../../../../generic/overflowButton";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsDsk.scss";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsTab.scss";
import { ovrOptions, ChipColorKeyComb, scrlStCls, ChipStatusComb, getMFCancelObj, ObScrollStyle } from "../../obConstants";
import { IMF, IMFSip, IMFHold } from "../../../../types/components/orderBook/obTypes";
import ObUtilHeader from "../../obContainer/obUtilHeader";
import Sort, { sort, eSortState } from "../../../../generic/sort";
import moment from "moment";
import dateTimeFormat from "../../../../service/dateTimeService";
import indexer, { IListObj } from "../../../../types/genericTypes";
import TocNoData from "../../../generic/tocNoData/tocNoData";
import DatePickerInt from "../../obContainer/obDatePickerInt";
import { toINR } from "../../../../service/numberFormat";
import { HObGroupBy, HOb2DGroupBy } from "../../../../service/orderBook/obGrpByHelper";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import ObMfSipDtlDsk from "../../obDetails/dsk/obMfSipDtlDsk";
import ObMfDtlDsk from "../../obDetails/dsk/obMfDtlDsk";
import { AMfCancelNrmTrd, AMfCancelHoldTrd } from "./../../../../service/orderBook/obApiService";
import { SearchHighLight } from "../../../../service/generic/searchHighlight";
import ee from "../../../../utils/eventEmitter";

export interface ObMutualFundProps {
	data: Array<any>;
	//true if table is history type else false
	isHistory?: boolean;
	getDates: (frmDt: Date, toDate: Date) => void;
	isSip: boolean;
	hidePageNav?: (hide: boolean) => void;
	reRenderCall?: (value: string) => void;
}

// heading for Mutul Fund Asset table

const heading: indexer = {
	scheme: "Scheme Name",
	amount: "Amount/Units"
};

const sortKey: indexer = {
	scheme: "schemeName",
	amount: "amount"
};

// SIP Headings
const headingSip = {
	period: "Period",
	symbol: "Symbol",
	frequency: "Frequency",
	next: "Next",
	amount: "Amount"
};

const ObMutualFund: React.FC<ObMutualFundProps> = (props) => {
	//holds executed order count ref
	const exeCountRef = React.useRef();
	//Show Open Ords on Top or not ref state
	const OpenOrdsTopRef = React.useRef<boolean>();
	const ovrOpts: Array<IListObj> = ovrOptions;
	if (props.data.length && !props.isHistory) {
		for (let i = 0; i < props.data.length; i++) {
			var temp: Array<IListObj> = [];
			let dp: IMF = props.data[i];
			let dpSip: IMFSip = props.data[i];
			//current day order options
			if (!props.isSip) {
				if (dp.isModify as boolean) {
					temp.push(ovrOpts[0]);
				}
				if (dp.isCancel) {
					temp.push(ovrOpts[1]);
				}
			}
			//sip options
			if (props.isSip) {
				if (dpSip.isCancel) {
					temp.push(ovrOpts[0]);
				}
				if (dpSip.isModified) {
					temp.push(ovrOpts[1]);
				}
			}
			temp.push(ovrOpts[4]);
			dp["ovrOpts"] = temp;
		}
	}
	// tableData data is shown in the table
	// tableData contains, sorted, filtered, searched data
	// wherever initial data needs to be sent, send initialData
	const initialData = [props.data.map((data: any, index: number) => ({ ...data, id: index, history: props.isHistory }))];

	// filteredData contains filtered, searched data
	const [filteredData, setFilteredData] = React.useState<Array<Array<{}>>>(initialData);

	// let filteredData: Array<any> = initialData;

	// tableData is shown in the table
	// tableData contains sorted, filtered, searched data
	let [tableData, setTableData] = useState(initialData);

	let mfHistoryData: Array<{ [x: string]: Array<IMF> }> = [{}];
	useEffect(() => {
		setTableData([props.data.map((data: any, index: number) => ({ ...data, id: index, history: props.isHistory }))]);
		//ref to initial toggle state of show open orders on top
		OpenOrdsTopRef.current = true;
		// check that props.data is not undefined/null, group it(open and others) and update tabledata

		if (props.data) {
			if (!props.isHistory && OpenOrdsTopRef.current) {
				let temp0: Array<any> = [];
				if (!props.isSip) {
					temp0 = HOb2DGroupBy(props.data, "status", ["accepted"]);
					exeCountRef.current = temp0[1].length;
				}
				if (props.isSip) {
					temp0 = HOb2DGroupBy(props.data, "status", ["running"]);
				}
				setTableData(temp0);
			}
		}

		return () => {
			setTableData([[{}]]);
		};
	}, [props.data, props.isHistory, props.isSip]);
	//kept outside because state data updating in async mode
	if (props.isHistory) {
		mfHistoryData = tableData.map((group: any) => HObGroupBy(group, "txnDate", "T"));
	}

	const [sortedColumnState, setSortedColumnState] = useState({ colName: null as string | null, sortState: eSortState.ASC });

	// state for mf popup handling
	const [popupDataIndex, setPopupDataIndex] = React.useState<[number | string, number, string?]>();

	function onSort(data: Array<Array<any>>, sortState: eSortState, sortKey: string) {
		setSortedColumnState({ colName: heading[sortKey], sortState: sortState });
		setTableData(data);
	}

	const MfTxnType: indexer = {
		FP: "Fresh Purchase",
		AP: "Add. Purchase",
		R: "Reedem",
		XSIP: "XSIP"
	};

	//after applying filters following method will invoked to show the updated results
	function onDataFilter(data: Array<any>, sText: string = "", type?: string) {
		setFilteredData(data);

		// sort only if colName is present, otherwise there is no need to sort
		if (sortedColumnState.colName) {
			const colNameKey = Object.keys(heading).find((key) => heading[key] === sortedColumnState.colName)!;
			sort(data, sortedColumnState.sortState, sortKey[colNameKey], onSort);
		}
		//highlightes the search text
		if (sText) {
			const SearchText: string = sText.toLowerCase();
			data[0].map((ord: IMF) => {
				ord.schemeName = SearchHighLight(ord.schemeName, SearchText);
				return true;
			});
		}

		if (type === "search" && OpenOrdsTopRef.current && !props.isHistory) {
			setTableData(HOb2DGroupBy(data[0], "status"));
		} else {
			setTableData(data);
		}
	}
	// this function excute on clicking any row
	function onRowClick(data: IMF | IMFSip, groupIndex: number | string, index: number, e?: any) {
		if (
			e &&
			!e.nativeEvent.path.find((m: HTMLElement) => m.className && (m.className.indexOf("check") >= 0 || m.className.indexOf("menu") >= 0))
		) {
			setPopupDataIndex([groupIndex, index]);
		}
	}
	//overflow option selection

	function optSelection(id: string | number, data: any) {
		id = typeof id === "string" ? id.toLowerCase() : id;
		switch (id) {
			case "details":
				setPopupDataIndex([data.gI, data.ind]);
				break;
			case "cancel":
				cancelOrder(data.data);
				break;
			default:
				console.log("404");
				break;
		}
	}

	let ordCancelledSuccList: Array<string> = [],
		ordCancelledFailList: Array<string> = [],
		ordsListToCancel: Array<string> = [];

	// runs after all cancel api response
	function cancelCallback(res: any) {
		if (res.data) {
			// if success
			ordCancelledSuccList.push(res.data);
		} else {
			// if error
			ordCancelledFailList.push(res.error);
		}

		// when we get all the responses
		if (ordCancelledSuccList.length + ordCancelledFailList.length === ordsListToCancel.length) {
			//show toast message
			ee.emit("showToast", { message: `Cancelled ${ordsListToCancel.length} Orders`, color: "cancell" });
			props.reRenderCall && props.reRenderCall("today");
		}
	}

	// TO DISCUSS: Whick paramenters to send in the body of AMfCancelNrmTrd in both sip and normal
	function cancelOrder(data: IMF | IMFSip | IMFHold) {
		ordsListToCancel.push(data.txnID);
		if (data.status.toLowerCase() === "on hold") {
			AMfCancelHoldTrd(cancelCallback, getMFCancelObj(data));
		} else {
			AMfCancelNrmTrd(cancelCallback, getMFCancelObj(data));
		}
	}

	function mfRow(item: IMF, groupIndex: number, index: number) {
		return (
			<>
				<li className="mf_data ins_data" key={index} onClick={(e) => onRowClick(item, groupIndex, index, e)}>
					<div className="col time">
						<span>{item.txnTime}</span>
					</div>
					<div className="col txn_typ">
						<span>
							<Tag
								value={item.txnType === "R" ? "S" : "B"}
								shape="mini_circle"
								color={item.txnType === "R" ? "red" : "green"}
								height="22px"
								width="22px"
							/>
						</span>
					</div>
					<div className="col scheme">
						<span dangerouslySetInnerHTML={{ __html: item.schemeName }}></span>
					</div>
					<div className="col amt_type">
						<span>{MfTxnType[item.txnType]}</span>
					</div>
					<div className="col amt taRight">
						<span>{item.amount !== "0" ? "₹" + toINR(item.amount, 2) : item.units}</span>
					</div>
					<div className="col sts">
						<span>
							<Tag value={ChipStatusComb[item.status.toLowerCase()]} shape="chip" color={ChipColorKeyComb[item.status.toLowerCase()]} />
						</span>
					</div>
					{!props.isHistory && (
						<div className="col menu">
							<OverflowButton
								defaultValue={"modify"}
								dropdownOptions={item.ovrOpts ? item.ovrOpts : []}
								onSelect={(id, data) => optSelection(id, data)}
								onHover={true}
								data={{
									data: item,
									gI: groupIndex,
									ind: index
								}}
							/>
						</div>
					)}
				</li>
			</>
		);
	}
	function nonSip() {
		return (
			<>
				<div className={"mf_table ins_tabl" + (props.isHistory ? " history" : "")}>
					{/* ob Equity Header Row */}
					{((props.isHistory && initialData[0].length > 0) || !props.isHistory) && (
						<ul className={scrlStCls.pOffset + " hdr_row list-unstyled"}>
							<li>
								<div className="col time"> </div>
								<div className="col txn_typ"> </div>
								<div className="col scheme">
									{!props.isHistory && (
										<Sort
											sortList={filteredData}
											sortedColName={sortedColumnState.colName}
											sortKey={sortKey.scheme}
											onSort={onSort}
											colName={heading.scheme}
										/>
									)}
									{props.isHistory && heading.scheme}
								</div>

								<div className="col amt_type"></div>
								<div className="col amt taRight">{heading.amount}</div>
								<div className="col sts"></div>
								{!props.isHistory && <div className="col menu"> </div>}
							</li>
						</ul>
					)}
					<div className={props.data.length > 0 ? "ObScrollCont" : ""} style={ObScrollStyle(props.data.length > 0 ? true : false)}>
						{props.isHistory || props.isSip ? (
							mfHistoryData.map((group: any, groupIndex: number) =>
								Object.keys(group).map((date: any, index) => {
									return (
										<React.Fragment key={index}>
											<ul className={scrlStCls.freeze + " eq_hist_date hist_date"} key={"dtGp" + index}>
												<li>{moment(date).format("DD MMMM YYYY")}</li>
											</ul>
											<ul className={scrlStCls.toContext} key={"dtUlDet" + index}>
												{group[date].map((row: any, index: number) => (
													<React.Fragment key={index}>{mfRow(row, date, index)}</React.Fragment>
												))}
											</ul>
										</React.Fragment>
									);
								})
							)
						) : (
							<>
								{
									!!tableData.length &&
										tableData.map((group: any, groupIndex: number) =>
											// Object.keys(group).map((grp: any, index) =>
											{
												return (
													<React.Fragment key={groupIndex}>
														{group.length > 0 && (
															<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
																{/* {tableData.map((group, groupIndex) => */}
																{group.map((row: any, index: number) => (
																	<React.Fragment key={index}>{mfRow(row, groupIndex, index)}</React.Fragment>
																))}
																{/* )} */}
															</ul>
														)}
													</React.Fragment>
												);
											}
										)
									// )
								}
							</>
						)}
					</div>
				</div>
			</>
		);
	}

	function sipOrders() {
		return (
			<div className="sip_type2_table ins_tabl">
				{/* ob MF SIP Header Row */}

				<ul className="hdr_row">
					<li>
						<div className="col period">{headingSip.period}</div>
						<div className="col sym">{headingSip.symbol}</div>
						<div className="col freqc">{headingSip.frequency}</div>
						<div className="col next">{headingSip.next}</div>
						<div className="col amt taRight">{headingSip.amount}</div>
						<div className="col sts"> </div>
						<div className="col menu"></div>
					</li>
				</ul>

				{
					!!tableData.length &&
						tableData.map((group: any, groupIndex: number) =>
							// Object.keys(group).map((grp: any, index) =>
							{
								return (
									<div
										className={props.data.length > 0 ? "ObScrollCont" : ""}
										style={ObScrollStyle(props.data.length > 0 ? true : false)}
										key={groupIndex}
									>
										{group.length > 0 && (
											<ul key={groupIndex} className={"blockDivider child" + groupIndex}>
												{/* {tableData.map((group, groupIndex) => */}
												{group.map((item: IMFSip, index: number) => (
													<React.Fragment key={index}>
														<li
															className="sip_type2_data ins_data"
															onClick={(e) => onRowClick(item, groupIndex, index, e)}
														>
															<div className="col period">
																<span className="per1">
																	{moment(dateTimeFormat(item.SIPStartDate)).format("DD MMM ‘YY")}
																</span>
																<span className="per1">
																	{moment(dateTimeFormat(item.SIPEndDate)).format("DD MMM ‘YY")}
																</span>
															</div>
															<div className="col sym">
																<span dangerouslySetInnerHTML={{ __html: item.schemeName }}></span>
															</div>
															<div className="col freqc">
																<span className="tCC">
																	{item.frequency.toLowerCase()} (
																	{item.status.toLowerCase() === "running"
																		? parseInt(item.totalInstalments) - parseInt(item.instalmentsPending)
																		: 0}
																	/{item.totalInstalments})
																</span>
															</div>
															<div className="col next">
																{/* <span>21 Dec 19</span> */}
																<span>{item.nextDueDate ? item.nextDueDate : "--"}</span>
															</div>
															<div className="col amt taRight">
																<span>₹{toINR(item.amount, 3)}</span>
															</div>
															<div className="col sts">
																<span>
																	<Tag
																		value={ChipStatusComb[item.status.toLowerCase()]}
																		shape="chip"
																		color={ChipColorKeyComb[item.status.toLowerCase()]}
																	/>
																</span>
															</div>
															<div className="col menu">
																<OverflowButton
																	defaultValue={"modify"}
																	dropdownOptions={item.ovrOpts ? item.ovrOpts : []}
																	onSelect={(id, data) => optSelection(id, data)}
																	onHover={true}
																	data={{
																		ordData: item,
																		gI: groupIndex,
																		ind: index
																	}}
																/>
															</div>
														</li>
													</React.Fragment>
												))}
											</ul>
										)}
									</div>
								);
							}
						)
					// )
				}
			</div>
		);
	}
	return (
		<>
			{/* UH start */}
			<ObUtilHeader
				leftSideText={
					!props.isHistory ? (
						<div className="executed">
							<span className="text">{props.isSip ? "Active SIPs" : "Executed Orders"}: </span>
							<span className="value">
								{!props.isSip
									? exeCountRef.current + " /" + initialData[0].length
									: tableData[0]
									? tableData[0].filter((row: IMFSip) => row.status.toLowerCase() === "running").length
									: 0}
							</span>
						</div>
					) : (
						<DatePickerInt plusDays={15} sendDates={props.getDates} />
					)
				}
				data={initialData}
				searchKey="schemeName"
				onDataFilter={onDataFilter}
				onFilterClick={(tgl) => {
					OpenOrdsTopRef.current = tgl;
				}}
				filterReqData={{
					status: "status",
					aType: props.isSip ? "mfSip" : "mf",
					showOpenOrderOnTop: OpenOrdsTopRef.current,
					showOpenOrderTgl: props.isHistory ? false : true,
					isHistory: props.isHistory ? true : false
				}}
				onSearchClick={(e) => {
					// if exists, then call it
					// props.hidePageNav && props.hidePageNav(e);
				}}
			/>
			{/* UH end */}

			{!props.isSip && nonSip()}
			{props.isSip && sipOrders()}
			{(tableData.filter((g: Array<any>) => g.length > 0).length <= 0 || mfHistoryData.length <= 0) && initialData[0].length > 0 && (
				<TocNoData data={initialData} callBackMeth={onDataFilter} />
			)}
			{/* tableData[groupIndex][index] */}
			{popupDataIndex && (
				<ObAssetDetailPopup>
					{props.isSip ? (
						<ObMfSipDtlDsk
							data={tableData[popupDataIndex[0] as number][popupDataIndex[1]]}
							onBackClick={() => setPopupDataIndex(undefined)}
							onCancelClick={() => cancelOrder(tableData[popupDataIndex[0] as number][popupDataIndex[1]])}
						/>
					) : (
						<ObMfDtlDsk
							data={
								props.isHistory
									? mfHistoryData[0][popupDataIndex[0]][popupDataIndex[1]]
									: tableData[popupDataIndex[0] as number][popupDataIndex[1]]
							}
							onBackClick={() => setPopupDataIndex(undefined)}
							onCancelClick={() => cancelOrder(tableData[popupDataIndex[0] as number][popupDataIndex[1]])}
						/>
					)}
				</ObAssetDetailPopup>
			)}
		</>
	);
};

export default ObMutualFund;
